import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useOrgBranding, isParcelinkHost } from '@/components/OrgMark';
import { RunmarkWordmark } from '@/components/brand/RunmarkMark';
import { headerIdentity } from '@/lib/headerIdentity';

// ── The chrome around the sign-in pages ──────────────────────────────────────
// Whose name goes at the top is decided by headerIdentity (src/lib): the
// tenant's, Parcelink's on Parcelink's own hosts, neutral Runmark on the
// shared tenant host. It used to hard-code Parcelink's logo and "Crew Portal".
const MinimalLayout = ({ children }) => {
  const brand = useOrgBranding();
  const id = headerIdentity(brand, !isParcelinkHost());

  return (
    <div className="shell-gradient min-h-screen text-foreground">
      <header className="sticky top-0 z-40 border-b border-border/70 bg-background/70 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-3">
            {id.kind === 'runmark' ? (
              <RunmarkWordmark />
            ) : (
              <>
                {id.kind === 'logo' ? (
                  <img src={id.src} alt={`${id.title} logo`} className="h-10 w-auto" />
                ) : null}
                <div>
                  <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary">{id.title}</p>
                  <p className="text-xs text-muted-foreground">{id.subtitle}</p>
                </div>
              </>
            )}
          </Link>
        </div>
      </header>

      <main className="mx-auto flex min-h-[calc(100vh-64px)] w-full max-w-7xl items-center px-4 py-8 sm:px-6 sm:py-10 lg:px-8 lg:py-12">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="w-full"
        >
          {children}
        </motion.div>
      </main>
    </div>
  );
};

export default MinimalLayout;
